import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTListItem from '../../../_common/ListItem'
import Checklist from '../../../_common/_icons/Checklist'
import EmotionHappy from '../../../_common/_icons/EmotionHappy'
import EmotionNormal from '../../../_common/_icons/EmotionNormal'
import EmotionSad from '../../../_common/_icons/EmotionSad'

import ContentSummary from './ContentSummary'
import EadRequests from "../../../../requests/ead-requests"
import MCLoading from "../../../_minha-central/Loading"
import FileSaver from "file-saver"

class NRTCourseSummary extends Component {


    state = {
        userFormDTOs: [],
        grade: null,
        total: null,
        loadingDownload: false
    }

    async componentDidMount() {
        const {modCode, clsCode, user, release} = this.props

        const filter = {
            bestResults: true
        }
        if (user) filter.usrCode = user.code
        if (modCode) filter.modCode = modCode
        if (clsCode) filter.clsCode = clsCode

        const result = await EadRequests.searchUserForms(filter)

        const userForms = result.userform
        const grade = userForms ? userForms.map(f => f.grade * 100.0 / f.value).reduce((total, next) => total + next, 0) / userForms.length : null
        console.log(userForms, "forms")

        this.setState({
            name: user.personDTO.name,
            userFormDTOs: userForms,
            grade,
            release,
            modCode
        })
    }

    downloadCertificate = async () => {

        this.setState({
            loadingDownload: true
        })

        const {user} = this.props
        const {name, release} = this.state
        const result = await EadRequests.generateCertificate({
            prsName: name,
            prlCode: user.accountDTO.productReleaseDTO.code,
            prsCode: user.personDTO.code,
            accCode: this.props.accountCode
        })

        const blob = new Blob([result], {
            type: 'application/pdf'
        })

        await FileSaver.saveAs(blob, 'certificado.pdf')
        this.setState({
            loadingDownload: false
        })
    }

    printGrade = (dto) => {

        const {
            grade,
            best,
            formDTO,
            value,
            openAnswersNotCorrected
        } = dto

        if (openAnswersNotCorrected)
            return <span style={{
                fontSize: '.7rem',
                fontWeigth: 200,
                opacity: .7,
                textDecoration: 'italic',
            }}>aguardando correção</span>

        const formCode = formDTO.code

        if (!this.props.context.eadAnswers)
            return grade

        const userAnswer = this.props.context.eadAnswers[formCode]


        if (!!userAnswer) {

            if (userAnswer.grade === value) {
                return <React.Fragment>
                    <img src={require('./star.png')} style={{width: 16, height: 16, marginRight: 5}}/>
                    {grade}

                </React.Fragment>
            } else if (userAnswer.best) {
                return grade
            } else {
                return <React.Fragment>
                    <span style={{fontSize: '.65rem'}}>
                        Você tirou {userAnswer.grade} nesta tentativa!
                        Vamos manter a sua maior nota:
                    </span>
                    {grade}
                </React.Fragment>
            }

        } else {
            return grade
        }


    }


    render() {
        const {
            typeSummary,
            finished,
            contentName,
            minApproval,
            nextContentSumary,
            onNextContentButtonSumary,
            history,
            code,
            grades,
        } = this.props

        const {
            grade, name, userFormDTOs,
            modCode,
        } = this.state

        if (!name)
            return <MCLoading/>

        const resultIcons = {
            happy: <EmotionHappy width={50}/>,
            normal: <EmotionNormal width={50}/>,
            sad: <EmotionSad width={50}/>
        }


        return (
            <div className='summary-content-container'>
                <div className="container-summary">
                    <ContentSummary history={history}
                                    nextContentSummary={nextContentSumary}
                                    onNextContentButtonSummary={onNextContentButtonSumary}
                                    code={typeSummary === 'module' ? modCode : code}
                                    grade={grade ? grade.toFixed(2) : null}
                                    userName={name}
                                    name={contentName}
                                    typeSummary={typeSummary}
                                    finished={finished}
                                    minApproval={minApproval}
                                    downloadCertificate={this.downloadCertificate}
                                    loadingDownload={this.state.loadingDownload}
                                    grades={grades}
                    />
                    {
                        userFormDTOs.length > 0 &&
                        <Fragment>
                            <div className="content-list">
                                <p>Pontuação</p>
                                <ul>
                                    {
                                        userFormDTOs.map((dto) => {
                                            return (
                                                <NRTListItem className={'pontuation-list'}>
                                                    <span>
                                                        <Checklist width={'1.4rem'}/>
                                                    </span>
                                                    <span>{dto.formDTO.title}</span>
                                                    <span>
                                                        {this.printGrade(dto)}

                                                        </span>
                                                    <span style={{
                                                        background: 'none',
                                                        padding: 0,
                                                        paddingLeft: '0.3rem',
                                                        color: '#B4B6BA'
                                                    }}> em {dto.value}
                                                    </span>
                                                    <div className="emotion">
                                                        {
                                                            minApproval &&
                                                            (dto.grade / dto.value) < minApproval &&
                                                            resultIcons["sad"]
                                                        }
                                                        {
                                                            minApproval &&
                                                            (dto.grade / dto.value) === minApproval &&
                                                            resultIcons["normal"]
                                                        }
                                                        {
                                                            minApproval &&
                                                            (dto.grade / dto.value) > minApproval &&
                                                            resultIcons["happy"]
                                                        }
                                                    </div>
                                                </NRTListItem>)
                                        })
                                    }
                                </ul>
                            </div>
                        </Fragment>
                    }
                </div>
            </div>
        )
    }
}


NRTCourseSummary.propTypes = {
    userCanProceedToNextContent: PropTypes.bool.isRequired,
    typeSummary: PropTypes.string.isRequired,
    grade: PropTypes.number,
    name: PropTypes.string.isRequired,
    emotion: PropTypes.string,
    pontuationList: PropTypes.arrayOf(
        PropTypes.shape({
            questionFormTitle: PropTypes.string,
            pontuation: PropTypes.number
        })
    )
}

NRTCourseSummary.defaultProps = {}

export default NRTCourseSummary



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/CourseSummary/index.js